import styled, { css } from 'styled-components'
import { Button, Image, Row, Column } from '@sainsburys-tech/bolt'
import { remCalculator } from '../../../../helpers/theming/utilities'
import { themeContract } from '../M023.theme.contract'

const wrapperMinHeight = 225
const imagePadding = (props) => remCalculator(props.theme.size.spacing.lg)

const ServiceButton = styled(Button)`
  color: ${(props) => props.theme.color.monochrome[themeContract[props.theme.channel].serviceButton.color]};
  background-color: ${(props) =>
    props.theme.color.monochrome[themeContract[props.theme.channel].serviceButton.background]};
  border-color: ${(props) => props.theme.color.monochrome[themeContract[props.theme.channel].serviceButton.border]};
  white-space: nowrap;
  display: flex;
  justify-content: center;

  &:hover {
    color: ${(props) => props.theme.color.monochrome[themeContract[props.theme.channel].serviceButton.color]};
    background-color: ${(props) =>
      props.theme.color.monochrome[themeContract[props.theme.channel].serviceButton.background]};
    border-color: ${(props) => props.theme.color.monochrome[themeContract[props.theme.channel].serviceButton.border]};
  }
`

const M023PropositionsCard = styled.button`
  display: flex;
  justify-content: center;
  min-width: 100%;
  min-height: 184px;
  padding: 10px;
  margin: 0;
  border: none;
  border-radius: ${(props) => props.theme.size.border.radius.base};
  background-color: ${(props) => props.theme.color.monochrome[themeContract[props.theme.channel].background.color]};
  min-height: auto;
  margin: 0 auto;
  min-height: 62px;
  font-size: 0.75rem;

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].sm}) {
    font-size: ${(props) => remCalculator(props.theme.font.size.root)};
  }

  div {
    max-width: 800px;
    display: flex;
    justify-content: center;
    text-align: left;
    @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].sm}) {
      align-items: center;
    }
  }

  strong {
    padding: 0 10px;
  }

  span {
    display: flex;
    flex: 0 0 auto;
    align-items: center;
    font-weight: ${(props) => props.theme.font.weight.bold};
    color: ${(props) => props.theme.color.monochrome.darker};
    border-left: none;
    text-decoration: underline;

    padding-left: 10px;
    height: 25px;
    @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].sm}) {
      height: 32px;
      border-left: ${(props) => props.theme.size.border.width.sm} solid ${(props) => props.theme.color.monochrome.base};
    }
  }
`

const PropositionsWrapper = styled.div`
  display: flex;
  justify-content: center;
`

const M023Image = styled(Image)`
  background-size: contain;
  background-repeat: no-repeat;
  background-position: top right;
  top: 0;
  right: 0;
  height: 30px;

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].sm}) {
    background-position: center;
    height: 40px;
  }

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].md}) {
    background-position: right;
  }
`

const SmallCta = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].sm}) {
    flex-direction: row;
    justify-content: center;
    display: none;
  }
`

const Wrapper = styled(Row)`
  justify-content: space-between;
  align-items: center;
  min-width: 100%;
  min-height: 276px;
  border: none;
  border-radius: ${(props) => props.theme.size.border.radius.base};
  background-color: ${(props) => props.theme.color.monochrome[themeContract[props.theme.channel].background.color]};
  h4 {
    line-height: 1.5rem;
  }

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].sm}) {
    min-height: ${wrapperMinHeight}px;
  }
`

const TextWrapper = styled(Column)`
  margin-top: ${(props) => remCalculator(props.theme.size.spacing.md)};
  margin-bottom: ${(props) => remCalculator(props.theme.size.spacing.md)};
  display: flex;
  flex-direction: column;
  justify-content: left;
  align-items: flex-start;
  color: ${(props) => props.theme.color.monochrome.darker};

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].lg}) {
    padding-left: ${(props) => remCalculator(props.theme.size.spacing.lg)};
  }
`

const buttonWrapperCSS = css`
  margin: ${(props) => remCalculator(props.theme.size.spacing.lg)} 0 0;
  border-color: currentColor;
  display: flex;
  align-items: center;
  justify-content: center;
`

const ButtonWrapperMd = styled.div`
  ${buttonWrapperCSS}
  display: none;

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].sm}) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].md}) {
    display: none;
  }
`

const ButtonWrapperLg = styled.div`
  ${buttonWrapperCSS}
  display: flex;
  flex: auto;
  align-items: flex-start;
  justify-content: center;
  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].sm}) {
    display: none;
  }
  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].md}) {
    display: flex;
    align-items: flex-start;
    justify-content: center;
  }
`

const ImageWrapper = styled(Column)`
  display: flex;
  margin-right: 15px;
  margin-left: 15px;

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].md}) {
    display: block;
    height: 100%;
    padding-top: ${(props) => imagePadding(props)};
    padding-bottom: ${(props) => imagePadding(props)};
    align-items: center;

    img {
      min-height: ${(props) => `calc(${wrapperMinHeight}px - 2 * ${imagePadding(props)})`};
      object-fit: contain;
    }
  }
`

const PropositionsImage = styled(Image)`
  max-width: 100%;
`

export {
  ServiceButton,
  M023PropositionsCard,
  PropositionsWrapper,
  M023Image,
  SmallCta,
  Wrapper,
  TextWrapper,
  ButtonWrapperMd,
  ButtonWrapperLg,
  ImageWrapper,
  PropositionsImage
}
